export const categories = [
  {
    id: "c1",
    name: "网红塌房",
    slug: "wanghong-tafang",
    description: "头部网红人设崩塌现场、直播翻车、虚假宣传、带货翻车全记录",
    icon: "ri-fire-line",
    articleCount: 128,
    image: "https://readdy.ai/api/search-image?query=Influencer%20livestream%20studio%20setup%20with%20ring%20lights%20and%20cameras%2C%20dark%20dramatic%20atmosphere%20with%20red%20accents%2C%20social%20media%20influencer%20aesthetic%2C%20cinematic%20editorial%20photography&width=1200&height=600&seq=cat-c1&orientation=landscape",
  },
  {
    id: "c2",
    name: "明星黑料",
    slug: "mingxing-heiliao",
    description: "娱乐圈最劲爆的独家爆料、人设崩塌、出轨离婚、潜规则内幕",
    icon: "ri-star-line",
    articleCount: 256,
    image: "https://readdy.ai/api/search-image?query=Hollywood%20style%20red%20carpet%20event%20with%20paparazzi%20flash%20photography%2C%20dark%20atmosphere%20with%20bright%20camera%20flashes%2C%20celebrity%20scandal%20vibe%2C%20cinematic%20editorial%20photography&width=1200&height=600&seq=cat-c2&orientation=landscape",
  },
  {
    id: "c3",
    name: "反差视频",
    slug: "fancha-shipin",
    description: "人前一套人后一套，反差最大的视频实录与现场直击",
    icon: "ri-video-line",
    articleCount: 89,
    image: "https://readdy.ai/api/search-image?query=Split%20screen%20contrast%20concept%20with%20formal%20business%20suit%20on%20one%20side%20and%20party%20scene%20on%20other%2C%20dramatic%20lighting%20contrast%2C%20dark%20background%20with%20red%20and%20gold%20accents%2C%20cinematic%20editorial%20photography&width=1200&height=600&seq=cat-c3&orientation=landscape",
  },
  {
    id: "c4",
    name: "每日大赛",
    slug: "meiri-dasai",
    description: "每日精选最劲爆的瓜，网友投票选出今日最大瓜王",
    icon: "ri-trophy-line",
    articleCount: 312,
    image: "https://readdy.ai/api/search-image?query=Trophy%20and%20microphone%20on%20pedestal%20with%20dramatic%20spotlight%2C%20competition%20winner%20atmosphere%2C%20dark%20background%20with%20gold%20and%20red%20lighting%2C%20cinematic%20editorial%20photography&width=1200&height=600&seq=cat-c4&orientation=landscape",
  },
];